/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EEmployeeType } from "../types/EEmployeeType.ts";

/**
 * @description 0 = Internal | 1 = External |
 */
export const eEmployeeTypeSchema = z
  .union([z.literal(0), z.literal(1)])
  .describe(
    "0 = Internal | 1 = External | ",
  ) as unknown as ToZod<EEmployeeType>;
